import styled from "styled-components"

// eslint-disable no-undef

export const Container = styled.div`
  position: relative;
  top: 0;
  left: 0;
  min-height: ${({ maxHeight }) =>
    maxHeight
      ? "var(--content-body-height)"
      : "var(--content-body-height-without-footer)"};
  overflow-y: auto;
  overflow-x: hidden;
  width: 100%;
  @media screen and (max-width: 768px) {
    min-height: ${({ maxHeight }) =>
      maxHeight
        ? "var(--content-mobile-body-height)"
        : "var(--content-mobile-body-height-without-footer)"};
  }
`
